@if (reservationFetchComplete) {
    @if (reservations) {

        <div class="container">

            <app-pim-notification phase="Confirmation" class="mt-3 d-block"></app-pim-notification>

            <h2 class="confirmation-title" [attr.data-testid]="'confirmation-title'">{{"cn.title" | translate}}</h2>
            <p [innerHTML]='"cn.confirmationIsSentToEmail" | translate:{value: reservations[0].bookerProfile.emails[0]}' [attr.data-testid]="'confirmation-email'"></p>



            <div class="confirmation-data" [attr.data-testid]="'confirmation-data'">

                <app-confirmation-commondetails [reservation]="reservations[0]" [isMultiRoomBooking]="reservations.length > 1"></app-confirmation-commondetails>


                @for (reservation of reservations; track $index) {

                    @if (reservations.length == 1) {
                        <h4 class="room-details-title">{{'cn.roomDetails' | translate}}</h4>
                    }
                    @else {
                        <h4 class="room-details-title">{{'cn.roomDetailsMulti' | translate:{value: $index + 1} }}</h4>
                    }

                    <app-confirmation-roominfo [roomInfo]="reservation" [isMultiRoomBooking]="reservations.length > 1"></app-confirmation-roominfo>

                }


                <div class="confirmation-bottom-buttons d-print-none">
                    <p-button (click)="print()" [attr.data-testid]="'confirmation-print'">{{"cn.Print"|translate}}</p-button>
                    <p-button (click)="newReservation()" [attr.data-testid]="'confirmation-new-reservation'">{{"cn.MakeNewReservation"|translate}}</p-button>
                    @if (websiteUrl) {
                        <p-button (click)="goToWebsite()" [attr.data-testid]="'confirmation-go-home'">{{"cn.returnToWebsite"|translate}}</p-button>
                    }
                </div>
            </div>
        </div>
    }

    @else {
        <div class="container">
            <h2 class="confirmation-title" [attr.data-testid]="'confirmation-title'">{{"cn.ConfirmationGone" | translate}}</h2>
            <p [attr.data-testid]="'confirmation-open-too-long'">{{"cn.confirmationOpenTooLong" | translate}}</p>

            <div class="confirmation-bottom-buttons">

                <p-button (click)="newReservation()" [attr.data-testid]="'confirmation-new-reservation'">{{"cn.MakeNewReservation"|translate}}</p-button>
                @if (websiteUrl) {
                    <p-button (click)="goToWebsite()" [attr.data-testid]="'confirmation-go-home'">{{"cn.returnToWebsite"|translate}}</p-button>
                }
            </div>
        </div>
    }

}


